"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteSelectValidator = void 0;
const validator_1 = require("./validator");
const utils_1 = require("./utils");
const remoteChoice_1 = require("./remoteChoice");
class RemoteSelectValidator extends validator_1.CommonValidator {
    merge(props) {
        return new RemoteSelectValidator({ ...this.props, ...props });
    }
    path(path) {
        return this.merge({ path });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateType, this.validateOptions]
        });
    };
    validateType = async ({ ctx, next }) => {
        if (typeof ctx.value === "string") {
            return next();
        }
        ctx.addError({ type: "string" });
    };
    logCustom = async ({ rootCtx, ctx, next, options: { api: { search, internal } = {} } }) => {
        const path = (await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.path)) || "";
        const options = await (0, remoteChoice_1.getOptions)(path, search, internal);
        ctx.addMessageWithPath({ options });
        return next();
    };
    validateOptions = async ({ rootCtx, ctx, next, options: { api: { search, internal } = {} } }) => {
        const path = (await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.path)) || "";
        const options = await (0, remoteChoice_1.getOptions)(path, search, internal);
        if ((0, remoteChoice_1.isKnownValue)(options, ctx.value)) {
            return next();
        }
        return ctx.addError({ path });
    };
    isEmptyValue(value) {
        return value === undefined || value === null || value === "";
    }
}
exports.RemoteSelectValidator = RemoteSelectValidator;
